export const isRTL = () => localStorage.getItem('i18nextLng') === 'ar'
